export var IOperateType;

!function(IOperateType) {
    IOperateType.drawStart = "drawStart", IOperateType.drawEnd = "drawEnd", IOperateType.drawing = "drawing", 
    IOperateType.moving = "moving", IOperateType.moveStart = "moveStart", IOperateType.moveEnd = "moveEnd", 
    IOperateType.brushActive = "brushActive", IOperateType.brushClear = "brushClear";
}(IOperateType || (IOperateType = {}));
//# sourceMappingURL=type.js.map